export const environment = {
  production: true,
  host: 'ildes.co',
  port: '3000',
  protocol: 'https',
  releaseDate: '16/11/2025, 15:08:46',
  sentryApiKey: 'https://fab4d9e8e94daa525fe33136ee654514@o4507115044339712.ingest.de.sentry.io/4507120584097872',
  releaseVersion: '5.4.0',
  recaptchaSiteKey: '6LeJoFsrAAAAAOc8ARNvTRJTYS-8N3JMXQlxCIyN',
};
